var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 12.3594C9.625 12.6609 9.37967 12.9062 9.07812 12.9062H1.64062C1.33908 12.9062 1.09375 12.6609 1.09375 12.3594V3.28125H3.28125V1.09375H9.07812C9.37967 1.09375 9.625 1.33908 9.625 1.64062V3.28125H10.7188V1.64062C10.7188 0.735984 9.98277 0 9.07812 0H2.73438C1.22664 0 0 1.22664 0 2.73438V12.3594C0 13.264 0.735984 14 1.64062 14H9.07812C9.98277 14 10.7188 13.264 10.7188 12.3594V10.8281H9.625V12.3594ZM2.1875 1.18781V2.1875H1.18781C1.35289 1.72214 1.72216 1.35289 2.1875 1.18781Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7969 6.6961C13.7306 6.59684 12.1431 4.26562 10.0626 4.26562C7.98281 4.26562 6.39395 6.59591 6.32731 6.69512L6.12256 7L6.32731 7.30488C6.39395 7.40409 7.98281 9.73438 10.0626 9.73438C12.1431 9.73438 13.7306 7.40316 13.7969 7.3039L14.0001 7L13.7969 6.6961ZM12.0083 7.69202C11.5398 8.12476 10.8219 8.64062 10.0626 8.64062C8.93645 8.64062 7.91002 7.54761 7.4665 7.00003C7.91027 6.45211 8.93656 5.35938 10.0626 5.35938C11.1888 5.35938 12.2119 6.45321 12.6532 7.00044C12.5022 7.18763 12.2818 7.43939 12.0083 7.69202Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 7.54688C10.3645 7.54688 10.6094 7.30203 10.6094 7C10.6094 6.69797 10.3645 6.45312 10.0625 6.45312C9.76047 6.45312 9.51562 6.69797 9.51562 7C9.51562 7.30203 9.76047 7.54688 10.0625 7.54688Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 6.45312H5.25V7.54688H2.1875V6.45312Z",
    fill: "#4F4F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 4.26562H5.25V5.35938H2.1875V4.26562Z",
    fill: "#4F4F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 8.64062H5.25V9.73438H2.1875V8.64062Z",
    fill: "#4F4F4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 10.8281H8.53125V11.9219H2.1875V10.8281Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudits);
export default __webpack_public_path__ + "static/media/audits.8722726093f2dc7efe934ce48bc32584.svg";
export { ForwardRef as ReactComponent };